import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { getPhysicianDetails } from "../../../actions/ReferralAction";
import PhysicianDetails from "../components/PhysicianDetails";

const mapStateToProps = ({
    tabSessionStorageReAuthState,
    physicianDetailsState
}: ApplicationState) => ({
    tabSessionStorage: tabSessionStorageReAuthState.response,
    physicianDetailsState: physicianDetailsState.response,
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
    return {
        getPhysicianDetails: (referralId: number) => {
            dispatch(getPhysicianDetails(referralId));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PhysicianDetails);
